"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuiProvider = void 0;
const protocol_1 = require("../../protocol");
const utils_1 = require("../../utils");
const media_1 = require("../../utils/media");
const InjectUtils_1 = require("../InjectUtils");
class SuiProvider {
    constructor() {
        this.accountChangedHandler = null;
        // const GlobalWallet: {
        //     [key: string]: any;
        //     register: (wallet: any) => void;
        // } = {
        //     register: (wallet) => {
        //         GlobalWallet[wallet.chainName] = wallet; // 动态添加属性
        //     },
        // }
        // const event = new CustomEvent('wallet-standard:app-ready', { detail: GlobalWallet });
        // window.dispatchEvent(event);
        // this.suiWallet = GlobalWallet["suiMainnet"]
    }
    connectReady() {
        return true;
    }
    getSuiPublicKey() {
        return __awaiter(this, void 0, void 0, function* () {
            const suiAccount = yield this.connect();
            let publicKey = suiAccount.accounts[0].publicKey;
            return publicKey;
        });
    }
    parseConnectResponse(needPop, accountChange, signalChain, connectWalletNameSpace, connectRequestWalletResponse, dappInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let connectChain = [];
                connectWalletNameSpace.forEach(item => {
                    if (item.namespace === protocol_1.NameSpaceKeySui) {
                        connectChain.push(...item.chains);
                    }
                });
                let addresses = [];
                let extra = {};
                if (connectChain.length == 0) {
                    return undefined;
                }
                const suiPublicKey = yield this.getSuiPublicKey();
                connectChain.forEach((chainStr) => {
                    var _a;
                    let currentChain = (0, utils_1.getChainId)(chainStr);
                    let selectedAddress = connectRequestWalletResponse.address.find((addressItem) => {
                        return (addressItem.coinType === 784)
                            || (addressItem.namespaceChainId === chainStr);
                    });
                    if (selectedAddress) {
                        addresses.push(chainStr + ":" + selectedAddress.address);
                        extra[chainStr] = {
                            publicKey: (_a = selectedAddress.publicKey) !== null && _a !== void 0 ? _a : suiPublicKey
                        };
                    }
                });
                if (addresses && addresses.length > 0) {
                    let nameSpaceResponse = {
                        namespace: protocol_1.NameSpaceKeySui,
                        addresses: addresses,
                        methods: [...InjectUtils_1.SuiMethods],
                        extra: extra
                    };
                    return nameSpaceResponse;
                }
                return undefined;
            }
            catch (error) {
                throw error;
            }
        });
    }
    restoreConnect() {
        if ((0, media_1.isDevice)("mobile")) {
            return this.connect();
        }
        return Promise.resolve();
    }
    getSuiWallet() {
        return window.okxwallet.sui;
    }
    send(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.restoreConnect();
                (0, utils_1.logDebug)("suiProvider send request:", JSON.stringify(request));
                const method = request.method;
                let result;
                if (request.injectParams && this.getSuiWallet()) {
                    let originalRarams = request.injectParams;
                    switch (method) {
                        case "sui_signTransactionBlock":
                            const injectSignResult = yield this.getSuiWallet().features['sui:signTransactionBlock'].signTransactionBlock(originalRarams);
                            //{transactionBlockBytes: 'AAACAAhmAAAAAAAAAAAgcveY+LcJkCRT1LtVxlZh6eBBVKUGdl…7bLNXSJ4Qz1jZurage0aGdH6Zb+4CAAAAAAAAIAo1AAAAAAAA', hash: '2pxcesyfKVCs3EegDYUDeQ28m3V3tn5VR32aUZSdg3dc', signature: 'ADDzSloxm5wEQX4BaTMJEON9t/xGgZ66ybiy5uT4TUimdl6Q9/…NeA3YOy/QsAD4XwjQ0rSuNkeKyfNy+VZPtJsmnKWswbGHSw=='}
                            result = {
                                method: "sui_signTransactionBlock",
                                result: injectSignResult.signature
                            };
                            break;
                        case "sui_signAndExecuteTransactionBlock":
                            const injectSendResult = yield this.getSuiWallet().features['sui:signAndExecuteTransactionBlock'].signAndExecuteTransactionBlock(originalRarams);
                            result = {
                                method: "sui_signAndExecuteTransactionBlock",
                                result: injectSendResult.digest
                            };
                            break;
                        case "sui_signMessage":
                            const injectResult = yield this.getSuiWallet().features['sui:signMessage'].signMessage(originalRarams);
                            result = {
                                method: "sui_signMessage",
                                result: injectResult.signature
                            };
                            break;
                        case "sui_signPersonalMessage":
                            const injectPersonalResult = yield this.getSuiWallet().features['sui:signPersonalMessage'].signPersonalMessage(originalRarams);
                            result = {
                                method: "sui_signPersonalMessage",
                                result: injectPersonalResult.signature
                            };
                            break;
                    }
                }
                return result;
            }
            catch (e) {
                (0, utils_1.logDebug)("suiProvider send error:", e);
                throw e;
            }
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            return (_a = this.getSuiWallet()) === null || _a === void 0 ? void 0 : _a.features['standard:connect'].connect();
        });
    }
    singleConnect() {
        return this.connect();
    }
    addListener(accountChangeListener) {
        console.log("window.okxwallet configEventWithKey:", 'sui');
        this.accountChangedHandler = (publicKey) => {
            console.log("window.okxwallet configEventWithKey_sui:", Date.now(), 'sui', publicKey);
            if (publicKey) {
                accountChangeListener();
            }
        };
        window.okxwallet.sui.on('accountChanged', this.accountChangedHandler);
    }
    removeListener() {
        if (this.accountChangedHandler) {
            window.okxwallet.sui.removeListener('accountChanged', this.accountChangedHandler);
        }
    }
}
exports.SuiProvider = SuiProvider;
